module.exports = __webpack_public_path__ + "img/agriculture/square_icon8.8b320178.png";